<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Detalle Proceso</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('closeViewInfoHistoricoFD')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-title>Información Histórica</v-card-title>
    <v-card-text>
      <template v-for="(item, index) in cmp_InfoConvertida">
        <p v-if="item.texto === '--Titulo--'" class=" primary white--text text-center"><strong>{{item.titulo}}</strong> </p>
        <p v-else><strong>{{item.titulo}} : </strong> {{ item.texto }}</p>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="$emit('closeViewInfoHistoricoFD')">Cerrar</v-btn>
    </v-card-actions>
  </v-card>
    
</template>

<script>
export default {
  name: 'viewInfoHistoricoFD',
  components: {
    
  },
  props: {
    oInfoSelected: {
      type: Object,
      required: true,
    },

  },
  data() {
    return {
      
    }
  },
  methods: {
    
  }, //fin methods
  computed: {
    cmp_InfoConvertida () {
      
      return (this.oInfoSelected.infoForm || [])
        .filter(item => !["3","12", "15"].includes(String(item.TipoPregunta))) // Excluye 
        .map(item => {
            const tipo = String(item.TipoPregunta);
            // manejo segun el tipo
            const tiposQueUsanTexto = ["17", "16", "14", "13", "12", "11", "10", "9", "8", "7", "6", "5", "4", "2", "1"]; 
            const tiposQueUsanValor = ["99"];
            const tiposTitulos = ["0"] 

            let texto;
            if (tiposQueUsanTexto.includes(tipo)) {
              texto = item.TextoRespuesta;
            } else if (tiposQueUsanValor.includes(tipo)) {
              texto = item.ValorRespuesta;
            } else if (tiposTitulos.includes(tipo)) {
              texto = '--Titulo--';  // utilizo un valor conocivod
            } else {
              // Fallback por si llega un tipo no mapeado
              texto = item.TextoRespuesta ?? item.ValorRespuesta ?? "";
            }

            return { titulo: item.Titulo, texto };
          });
    }  
  } //fin computed
}
</script>

<style scoped>
</style>